import type { FC } from "react";
import { useMemo } from "react";

import { getTableColumns } from "../../columns/tableColumnsBuilder";
import { formatChangeWithSign, getDescriptionText, percentageSignOrZeroWrapper } from "../../tests/helpers";
import type { IMarketingChannelsPresetsProps } from "../../types";
import HeatmapWidgetTable from "../HeatmapWidgetTable/HeatmapWidgetTable";

const MarketingFocusTable: FC<IMarketingChannelsPresetsProps> = ({
    subTitleFilters,
    data,
    domains,
    isLoading,
    isPoP,
    ...props
}) => {
    const columns = useMemo(
        () =>
            data.length > 0 && !isLoading
                ? getTableColumns(domains, percentageSignOrZeroWrapper(), "Marketing focus", props.withOpacity)
                : [],
        [data.length, domains, isLoading],
    );

    const descriptionText = getDescriptionText(isPoP, "mmx.markteing.focus.description");

    return (
        <HeatmapWidgetTable
            data-automation="marketing-focus-table"
            title="mmx.markteing.focus.title"
            tooltip="mmx.markteing.focus.tooltip"
            data={data}
            columns={columns}
            isLoading={isLoading}
            descriptionText={descriptionText}
            subtitleFilters={subTitleFilters}
            formatter={formatChangeWithSign}
            {...props}
        />
    );
};

export default MarketingFocusTable;
